<script lang="ts" setup>
import { i18n } from '@/i18n';
import { computed } from 'vue';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    isRecovered?: boolean;
  }>(),
  {
    isRecovered: false,
  }
);

const computedClass = computed(() => {
  return props.isRecovered ? 'recovery-status--recovered' : 'recovery-status--not-recovered';
});

const displayText = computed(() => {
  return props.isRecovered ? t('内示回収ステータス:回収済') : t('内示回収ステータス:未回収');
});
</script>

<template>
  <div class="status-tag">
    <div class="status-tag__container" :class="computedClass">
      <span :class="computedClass">
        {{ displayText }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.status-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  &__container {
    justify-content: center;
    align-items: center;
    min-width: 80px;
    max-width: 80px;
    border-radius: 90px;
    padding-top: 4px;
    padding-bottom: 4px;
    font-family: Noto Sans JP;
    font-size: $fontSizeSS;
    line-height: 12px;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.recovery-status--recovered {
      background-color: $semanticSuccess;
      color: $semanticWhite;
    }

    &.recovery-status--not-recovered {
      background-color: $semanticWhite;
      border: 1px solid $borderDefault;
      color: $textSecondary;
    }
  }
}
</style>
